import * as angular from 'angular';
import { NoteConfirmDeletionModal } from './notes-confirm-delete-modal.service';

export const NoteConfirmDeletionModalModule = angular
  .module('noteConfirmDeletionModal', [])
  .service('NoteConfirmDeletionModal', NoteConfirmDeletionModal).name;
